import { PriceListStatistics } from '../../../../types';

import { IProductCondition } from './types';

export const getCondition = (
  name: 'new' | 'used',
  count: number
): IProductCondition => {
  return {
    name,
    from: 0,
    to: 0,
    count,
  };
};

export const getConditions = (
  priceListStatistics?: PriceListStatistics
): IProductCondition[] => {
  if (!priceListStatistics) {
    return [];
  }

  const conditionList: IProductCondition[] = [];

  conditionList.push(getCondition('new', priceListStatistics.new));
  conditionList.push(getCondition('used', priceListStatistics.used));

  return conditionList.length ? conditionList : [];
};
